import { Injectable } from '@angular/core';
import { API_Attachment, API_URL } from '../core/apiconfig';
import { HttpHeader } from '../core/httpheader';
import { RequestOptions, Http, Response } from '@angular/http';
import { Attachment } from './attachment.model';
import { Attachmentupdate } from './attachmentupdate.model';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';

@Injectable()
export class AttachmentService {

    private apiUrl: string;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private _http: Http, ) {
        this.apiUrl = API_URL + API_Attachment;
    }
    saveSignature(formData: FormData, signid: string,  seqno: number, totalAttachCount: number) {
        
        return this._http.put(this.apiUrl + '/SaveAttachment' + '/' + signid + '/' + seqno + '/' + totalAttachCount ,formData).map(
            (res: Response) => res);
    }

    getisValidSign(signatureID: any): Promise<Attachment> {

        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.get(this.apiUrl + '/IsValidAttachmentRequest/' + signatureID, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as Attachment)
            .catch(this.handleError);
    }

    // Handle Error

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }


}



// WEBPACK FOOTER //
// ./SignClient/app/attachment/attachment.service.ts